

































































































import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import { AnnouncementSetting } from '@/API';
import { SystemSettingInfo } from '@/appsync/graphql/systemSettingInfo';
import CustomSelect from '@/components/atoms/neon/CustomSelect.vue';
import CustomToggle from '@/components/atoms/neon/CustomToggle.vue';
import { i18n } from '@/plugins/i18n/i18n';

@Component({
  components: { CustomToggle, CustomSelect },
})
export default class GeneralSettingProfile extends Vue {
  @Prop()
  private isMultilanguageEnabled!: boolean;
  @Prop()
  private isJobSchedulerEnabled!: boolean;
  @Prop()
  private isPortalEnabled!: boolean;
  @Prop()
  private announcementSetting!: AnnouncementSetting;

  private announcementSettings: { [key: string]: string } = {
    UseV1: i18n.tc('commonSetting.general.useV1'),
    UseV2: i18n.tc('commonSetting.general.useV2'),
    NotUse: i18n.tc('commonSetting.general.notUse'),
  };

  private isMultilanguageEnabledCurrent = this.isMultilanguageEnabled;
  private isJobSchedulerEnabledCurrent = this.isJobSchedulerEnabled;
  private availableAnnouncementSettings: string[] = [];
  private selectedAnnouncementSetting: string = 'UseV1';

  private isMultilanguageSettingChanged: boolean = false;
  private isEventCalendarSettingChanged: boolean = false;
  private isAnnouncementSettingChanged: boolean = false;
  private isFormChanged: boolean = false;
  private dialog: boolean = false;

  public created(): void {
    this.availableAnnouncementSettings = Object.values(
      this.announcementSettings
    );
    this.selectedAnnouncementSetting = this.announcementSettings[
      this.announcementSetting
    ];
  }

  private checkMultilanguageSetting(value: boolean): void {
    this.isMultilanguageSettingChanged = this.isMultilanguageEnabled !== value;
    this.isMultilanguageEnabledCurrent = value;
    this.isFormChanged = this.checkForm();
  }

  private checkEventCalendarSetting(value: boolean): void {
    this.isEventCalendarSettingChanged = this.isJobSchedulerEnabled !== value;
    this.isJobSchedulerEnabledCurrent = value;
    this.isFormChanged = this.checkForm();
  }

  private checkAnnouncementSetting(value: string): void {
    this.isAnnouncementSettingChanged =
      this.announcementSetting !== this.getAnnouncementSettingKey(value);
    this.isFormChanged = this.checkForm();
  }

  private checkForm(): boolean {
    return (
      this.isMultilanguageSettingChanged ||
      this.isEventCalendarSettingChanged ||
      this.isAnnouncementSettingChanged
    );
  }

  private clickReset(): void {
    this.isMultilanguageEnabledCurrent = this.isMultilanguageEnabled;
    this.isJobSchedulerEnabledCurrent = this.isJobSchedulerEnabled;
    this.selectedAnnouncementSetting = this.announcementSettings[
      this.announcementSetting
    ];
    this.isMultilanguageSettingChanged = false;
    this.isEventCalendarSettingChanged = false;
    this.isAnnouncementSettingChanged = false;
    this.isFormChanged = false;
  }

  @Emit('save-general-setting')
  private saveGeneralSetting(): SystemSettingInfo {
    this.dialog = false;
    this.isFormChanged = false;
    return {
      isMultilanguageEnabled: this.isMultilanguageEnabledCurrent,
      isJobSchedulerEnabled: this.isJobSchedulerEnabledCurrent,
      isPortalEnabled: this.isPortalEnabled,
      announcementSetting: this.getAnnouncementSettingKey(
        this.selectedAnnouncementSetting
      ),
    };
  }

  private getAnnouncementSettingKey(value: string): AnnouncementSetting {
    for (var key in this.announcementSettings) {
      if (value === this.announcementSettings[key]) {
        if (key === AnnouncementSetting.UseV1) {
          return AnnouncementSetting.UseV1;
        } else if (key === AnnouncementSetting.UseV2) {
          return AnnouncementSetting.UseV2;
        } else {
          return AnnouncementSetting.NotUse;
        }
      }
    }
    return AnnouncementSetting.UseV1;
  }
}
